import type { ReactNode } from "react";

import "./FormControls.scss";

export function FormField({
  children,
  className = "",
  error,
  hint,
  htmlFor,
  label,
}: {
  children: ReactNode;
  className?: string;
  error?: ReactNode;
  hint?: ReactNode;
  htmlFor?: string;
  label?: ReactNode;
}) {
  return (
    <div className={`form-field ${className}`.trim()}>
      {label &&
        (htmlFor ? (
          <label className="form-field-label" htmlFor={htmlFor}>
            {label}
          </label>
        ) : (
          <span className="form-field-label">{label}</span>
        ))}
      {children}
      {error ? (
        <span className="form-field-message form-field-message--error">
          {error}
        </span>
      ) : (
        hint && <span className="form-field-message">{hint}</span>
      )}
    </div>
  );
}
